
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ContactForm from '../../components/ContactForm';
import ScrollToTopButton from '../../components/ScrollToTopButton';
import './EditorialPage.css';

const JaqueAlReyPage: React.FC = () => {
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  // Imágenes del proyecto Jaque al Rey
  const projectImages = [
    'https://pub-122ae695cb844f9984136ea14dacedd9.r2.dev/gema/proyectos/editoriales/jaque-al-rey/abel.webp',
    'https://pub-122ae695cb844f9984136ea14dacedd9.r2.dev/gema/proyectos/editoriales/jaque-al-rey/IMG_8756.webp',
    'https://pub-122ae695cb844f9984136ea14dacedd9.r2.dev/gema/proyectos/editoriales/jaque-al-rey/IMG_8757.webp',
    'https://pub-122ae695cb844f9984136ea14dacedd9.r2.dev/gema/proyectos/editoriales/jaque-al-rey/IMG_8773.webp',
    'https://pub-122ae695cb844f9984136ea14dacedd9.r2.dev/gema/proyectos/editoriales/jaque-al-rey/IMG_8793.webp',
    'https://pub-122ae695cb844f9984136ea14dacedd9.r2.dev/gema/proyectos/editoriales/jaque-al-rey/IMG_8907.webp',
    'https://pub-122ae695cb844f9984136ea14dacedd9.r2.dev/gema/proyectos/editoriales/jaque-al-rey/IMG_8989.webp'
  ];

  const creditsImage = 'https://pub-122ae695cb844f9984136ea14dacedd9.r2.dev/gema/proyectos/editoriales/jaque-al-rey/CREDITOS%20JAQUE%20AL%20REY.PNG';

  const openModal = (imageUrl: string) => {
    setSelectedImage(imageUrl);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <div className="project-page">
      <Header />
      <main className="project-main">
        {/* Hero Section */}
        <section className="project-hero">
          <div className="project-hero-content">
            <nav className="breadcrumb">
              <Link to="/" className="breadcrumb-link">Inicio</Link>
              <span className="breadcrumb-separator">→</span>
              <button
                onClick={() => {
                  navigate('/', {
                    state: {
                      filter: 'editoriales',
                      projectId: 'jaque-al-rey',
                      shouldShowAll: false
                    }
                  });
                }}
                className="breadcrumb-link breadcrumb-category"
              >
                Editorial
              </button>
              <span className="breadcrumb-separator">→</span>
              <span className="breadcrumb-current">Jaque al Rey</span>
            </nav>

            <h1 className="project-title">JAQUE AL REY</h1>

            {/* Navegación rápida */}
            <div className="project-quick-nav">
              <button 
                onClick={() => {
                  const gallerySection = document.querySelector('.project-gallery');
                  if (gallerySection) {
                    const header = document.getElementById('header');
                    const headerHeight = header ? header.offsetHeight + 20 : 100;
                    const elementPosition = gallerySection.getBoundingClientRect().top + window.pageYOffset;
                    window.scrollTo({
                      top: elementPosition - headerHeight,
                      behavior: 'smooth'
                    });
                  }
                }}
                className="quick-nav-btn"
              >
                <i className="fas fa-images"></i>
                Galería
              </button>
              <button 
                onClick={() => {
                  const creditsSection = document.querySelector('.project-credits');
                  if (creditsSection) {
                    const header = document.getElementById('header');
                    const headerHeight = header ? header.offsetHeight + 20 : 100;
                    const elementPosition = creditsSection.getBoundingClientRect().top + window.pageYOffset;
                    window.scrollTo({
                      top: elementPosition - headerHeight,
                      behavior: 'smooth'
                    });
                  }
                }}
                className="quick-nav-btn"
              >
                <i className="fas fa-users"></i>
                Créditos
              </button>
              <button 
                onClick={() => {
                  const contactSection = document.getElementById('contacto');
                  if (contactSection) {
                    const header = document.getElementById('header');
                    const headerHeight = header ? header.offsetHeight + 20 : 100;
                    const elementPosition = contactSection.getBoundingClientRect().top + window.pageYOffset;
                    window.scrollTo({
                      top: elementPosition - headerHeight,
                      behavior: 'smooth'
                    });
                  }
                }}
                className="quick-nav-btn"
              >
                <i className="fas fa-envelope"></i>
                Contacto
              </button>
            </div>
          </div>
        </section>

        {/* Gallery Section */}
        <section className="project-gallery">
          <div className="gallery-grid">
            {projectImages.map((image, index) => (
              <div 
                key={index} 
                className="gallery-item"
                onClick={() => openModal(image)}
              >
                <img 
                  src={image} 
                  alt={`Jaque al Rey - Imagen ${index + 1}`}
                />
                <div className="gallery-overlay">
                  <span className="gallery-zoom">🔍</span>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Credits Section */}
        <section className="project-credits">
          <h2 className="credits-title">Créditos del Proyecto</h2>
          <div className="credits-content">
            <img 
              src={creditsImage} 
              alt="Créditos Jaque al Rey"
              className="credits-image"
            />
          </div>
        </section>

        {/* Contact Section */}
        <section id="contacto" className="contact-section">
          <div className="inner">
            {/* Contact Hero */}
            <div className="contact-hero">
              <div className="contact-hero-content">
                <h2>
                  <span className="contact-title-accent">¿Te gustó este proyecto?</span>
                  <span className="contact-title-main">¡Trabajemos juntos!</span>
                </h2>
                <div className="contact-hero-text">
                  <p className="hero-question">
                    <i className="fas fa-lightbulb"></i>
                    ¿Tienes una idea similar en mente?
                  </p>
                  <p className="hero-description">
                    Jaque al Rey es un ejemplo de mi trabajo en <strong>estilismo editorial</strong> y moda estratégica. Cada proyecto es una oportunidad para experimentar con conceptos y estilos únicos.
                  </p>
                  <div className="contact-badges">
                    <span className="badge">Editorial</span>
                    <span className="badge">Moda Masculina</span>
                    <span className="badge">Estilismo</span>
                    <span className="badge">Dirección Artística</span>
                  </div>
                </div>
              </div>
            </div>
            {/* Contact Info Grid */}
            <div className="contact-info">
              <div className="contact-details">
                <h3>Información de Contacto</h3>
                <ul className="contact-list">
                  <li>
                    <a 
                      href="mailto:gema.ruiz.gordillo@gmail.com" 
                      className="contact-item-link"
                      title="Enviar email"
                    >
                      <i className="icon solid fa-envelope"></i>
                      <div>
                        <h4>Email</h4>
                        <span>gema.ruiz.gordillo@gmail.com</span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a 
                      href="tel:+34652847120" 
                      className="contact-item-link"
                      title="Llamar por teléfono"
                    >
                      <i className="icon solid fa-phone"></i>
                      <div>
                        <h4>Teléfono</h4>
                        <span>+34 652 847 120</span>
                      </div>
                    </a>
                  </li>
                  <li className="static-item">
                    <i className="icon solid fa-map-marker-alt"></i>
                    <div>
                      <h4>Ubicación</h4>
                      <span>Madrid, España</span>
                    </div>
                  </li>
                </ul>
                <h4>Sígueme en Redes Sociales</h4>
                <ul className="social-links">
                  <li>
                    <a 
                      href="https://www.instagram.com/geemaa_rg/" 
                      className="social-link instagram" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      title="Sígueme en Instagram"
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://www.tiktok.com/@usuario" 
                      className="social-link tiktok" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      title="Sígueme en TikTok"
                    >
                      <i className="fab fa-tiktok"></i>
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://www.linkedin.com/in/usuario" 
                      className="social-link linkedin" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      title="Conecta en LinkedIn"
                    >
                      <i className="fab fa-linkedin"></i>
                    </a>
                  </li>
                </ul>
                <div className="contact-note">
                  <strong>Tiempo de respuesta:</strong> Normalmente respondo en menos de 24 horas.
                </div>
                <div className="contact-cta">
                  <a 
                    href="tel:+34652847120" 
                    className="button secondary"
                    title="Llamar directamente"
                  >
                    <i className="fas fa-phone"></i>
                    Llamar Ahora
                  </a>
                </div>
              </div>
              <ContactForm />
            </div>
          </div>
        </section>
      </main>

      {/* Modal for full-size images */}
      {selectedImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>✕</button>
            <img 
              src={selectedImage} 
              alt="Jaque al Rey - Vista ampliada"
              className="modal-image"
            />
          </div>
        </div>
      )}

      <ScrollToTopButton />
      <Footer />
    </div>
  );
};

export default JaqueAlReyPage;
